import { connectFunctionsEmulator, getFunctions, httpsCallable, } from 'firebase/functions';
import { getEmulatorHost, getEmulatorPort } from '../emulator-detection.js';
const connectedInstances = new WeakSet();
/** Default region to align with emulator expectations. */
export const DEFAULT_FUNCTIONS_REGION = 'us-central1';
/** Returns the Functions instance for the provided app and region. */
export function getFirebaseFunctions(app, region = DEFAULT_FUNCTIONS_REGION) {
    return getFunctions(app, region);
}
/** Connects the Functions instance to the emulator once. */
export function connectFunctionsToEmulator(functions, config) {
    if (connectedInstances.has(functions)) {
        return;
    }
    connectFunctionsEmulator(functions, getEmulatorHost(config), getEmulatorPort(config));
    connectedInstances.add(functions);
}
/** Convenience wrapper around `httpsCallable` with typed responses. */
export function callable(functions, name, options) {
    return httpsCallable(functions, name, options);
}
//# sourceMappingURL=index.js.map